import { render, staticRenderFns } from "./OnboardingPrices.vue?vue&type=template&id=4bc8a59e&"
import script from "./OnboardingPrices.vue?vue&type=script&lang=ts&"
export * from "./OnboardingPrices.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingPrices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports